import React from "react";
import Spinner from "./Spinner";

interface LoadingComponentProps {
    styles?: string;
    backgroundColor?: string;
}

export default function LoadingComponent(props: LoadingComponentProps) {
    const { styles, backgroundColor = '' } = props;
    
    return (
        <div className={`${styles ? styles : 'pt-10'} ${backgroundColor}`}>
            <div className='mb-4 text-center mx-auto'>
                <div className="d-flex justify-content-center">
                    <Spinner />
                </div>
            </div>
        </div>
    );
}
